import React from 'react';
import {
  Autocomplete,
  TextField,
  CircularProgress,
  AutocompleteProps,
} from '@mui/material';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SingleSelectFieldProps {
  options: SelectOption[];
  value: SelectOption | null;
  onChange: (value: SelectOption | null) => void;
  label: string;
  placeholder?: string;
  loading?: boolean;
  loadingText?: string;
  noOptionsText?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

const SingleSelectField: React.FC<SingleSelectFieldProps> = ({
  options,
  value,
  onChange,
  label,
  placeholder = 'Selecione uma opção...',
  loading = false,
  loadingText = 'Carregando...',
  noOptionsText = 'Nenhuma opção encontrada',
  disabled = false,
  error = false,
  helperText,
  required = false,
  fullWidth = true,
  size = 'medium',
}) => {
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option: SelectOption) => option.label}
      value={value}
      onChange={(event, newValue: SelectOption | null) => {
        onChange(newValue);
      }}
      loading={loading}
      loadingText={loadingText}
      noOptionsText={noOptionsText}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          required={required}
          size={size}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
      isOptionEqualToValue={(option: SelectOption, value: SelectOption) => 
        option.value === value?.value
      }
      fullWidth={fullWidth}
    />
  );
};

export default SingleSelectField;
